import { Controller } from 'stimulus';

// Builder view of the Checklist tab (templates, and per-job question edits).
// Forms are plain HTML submits; this controller only shows/hides the inline
// editors and the options field. Reordering is handled by sortable_controller.
export default class extends Controller {
  toggleEdit(event) {
    const id = event.currentTarget.dataset.itemId;
    this.display(id).classList.add('hidden');
    this.form(id).classList.remove('hidden');
  }

  cancelEdit(event) {
    const id = event.currentTarget.dataset.itemId;
    this.form(id).classList.add('hidden');
    this.display(id).classList.remove('hidden');
  }

  typeChanged(event) {
    const select = event.currentTarget;
    const optionsField = select.closest('form').querySelector('.checklist-options-field');
    if (optionsField) optionsField.classList.toggle('hidden', select.value !== 'multiple_choice');
  }

  display(id) {
    return document.getElementById(`checklist-display-${id}`);
  }

  form(id) {
    return document.getElementById(`checklist-form-${id}`);
  }
}
